import { useGetQuery } from "../hooks";
import { getPerformedJobFields } from "../utils";
import Form from "./Form";
import { useDataContext, useUserContext } from "../contexts";

export default function PerformedJobEdit({ callback, id }) {
  const { user } = useUserContext();
  const { memberUsers, jobs } = useDataContext();

  const performedJobsQuery = useGetQuery("performed-jobs");

  if (performedJobsQuery.isLoading) {
    return null;
  }

  const performedJob = performedJobsQuery.data.find(
    (performedJob) => performedJob.id === id
  );

  if (!performedJob) {
    return "Performed job not found";
  }

  const performedJobFields = getPerformedJobFields(user, memberUsers, jobs);

  return (
    <Form
      path="performed-jobs"
      id={performedJob.id}
      method="PATCH"
      submitCallback={callback}
      initialValues={performedJob}
      fields={performedJobFields}
    />
  );
}
